import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import { paginatedRemove, useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { PriceOverrideDetailsResponseModel } from "@/features/priceOverrides/api/usePriceOverrideDetails";
import { clearCacheAfterPriceOverrideMutation } from "@/features/priceOverrides/api/clearCacheAfterPriceOverrideMutation";

export const usePriceOverrideDelete = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<PriceOverrideDetailsResponseModel>, string> = priceOverrideId => {
		return http({
			method: "DELETE",
			url: `/price-override/${priceOverrideId}`
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, priceOverrideId) => {
			queryClient.setQueryData(["priceOverrideDetails"], paginatedRemove<PriceOverrideDetailsResponseModel>(x => x.priceOverrideId === priceOverrideId));
			clearCacheAfterPriceOverrideMutation(queryClient);
		}
	});
};
